import headerBannersSlice from './slice';

export default headerBannersSlice.reducer;
